import React from "react";
import { FaIcon } from "lib/FaIcon";

import styles from "./SubscriptionsBellButton.module.scss";

function SubscriptionsBellButton({ hasCoverImage }) {
  return <FaIcon icon="fas fa-bell" className={`cursor-pointer ${hasCoverImage ? styles.whiteIcon : styles.icon}`} />;
}

export default SubscriptionsBellButton;
